/* eslint-disable no-case-declarations */
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { DealActionTypes, DealActionsUnion } from './actions';
import {
  Deal,
  DealVersion,
  DealVersionSelector,
  DealStatus,
  DealType
} from '../../types/deal.types';
import { DealState } from './state';

export const dealDefaultState: DealState = {
  deal: undefined,
  defaultVersion: undefined,
  selectedVersion: undefined,
  loaded: false,
  loading: false,
  error: undefined,
  useDefaultVersion: false
};

export function dealReducer(
  state = dealDefaultState,
  action: DealActionsUnion
): DealState {
  switch (action.type) {
    case DealActionTypes.Load:
      if (state.deal && state.deal.id === action.payload) {
        return {
          ...state,
          loaded: true,
          loading: true,
          error: undefined
        };
      } else {
        return {
          ...state,
          deal: undefined,
          defaultVersion: undefined,
          selectedVersion: undefined,
          loaded: false,
          loading: true,
          error: undefined
        };
      }

    case DealActionTypes.LoadSuccess:
      const { deal, defaultVersion } = action.payload;
      return {
        ...state,
        deal,
        defaultVersion,
        selectedVersion: selectVersion(state, deal, defaultVersion),
        loaded: true,
        loading: false,
        error: undefined,
        useDefaultVersion: false
      };

    case DealActionTypes.LoadFail:
      return {
        ...state,
        deal: undefined,
        loaded: false,
        loading: false,
        error: action.payload
      };

    case DealActionTypes.SetVersion:
      return {
        ...state,
        selectedVersion: action.payload as DealVersionSelector
      };

    case DealActionTypes.Reset:
      return dealDefaultState;

    case DealActionTypes.SetUseDefaultVersion:
      return {
        ...state,
        useDefaultVersion: true
      };
    case DealActionTypes.Reload:
      return {
        ...state,
        error: undefined
      };
    default:
      return state;
  }
}

export function selectVersion(
  state: DealState,
  deal: Deal,
  defaulVersion: DealVersionSelector
): DealVersionSelector {
  if (state.selectedVersion) {
    return state.selectedVersion;
  } else if (state.useDefaultVersion) {
    if (deal[defaulVersion]) {
      return defaulVersion;
    } else if (deal[DealVersionSelector.published]) {
      return DealVersionSelector.published;
    } else if (deal[DealVersionSelector.working]) {
      return DealVersionSelector.working;
    } else {
      throw new Error('Published version is not released');
    }
  } else {
    return selectInitialVersion(deal, defaulVersion);
  }
}

export function selectInitialVersion(
  deal: Deal,
  defaulVersion: DealVersionSelector
): DealVersionSelector {
  if (
    deal[DealVersionSelector.public] &&
    deal[DealVersionSelector.public].dealType === DealType.competitive &&
    deal[DealVersionSelector.public].status === DealStatus.bought
  ) {
    return DealVersionSelector.public;
  }
  if (deal[defaulVersion]) {
    return defaulVersion;
  } else if (deal[DealVersionSelector.published]) {
    return DealVersionSelector.published;
  } else if (deal[DealVersionSelector.working]) {
    return DealVersionSelector.working;
  } else {
    return DealVersionSelector.public;
  }
}
export const selectDeal = (dealState: DealState): Deal => dealState.deal;

export const selectCurrentDealVersion = (
  dealState: Observable<DealState>
): Observable<DealVersion> =>
  dealState.pipe(
    filter(({ deal }) => !!deal),
    map(({ deal, selectedVersion }) => deal[selectedVersion]),
    filter((version) => version !== undefined)
  );
